module.exports = __webpack_public_path__ + "img/tankRight.7e04651c.svg";